import { mergeClasses } from "@fluentui/react-components";
import { useGroupedWorkspaceDashboardStyles } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.styles";
import { IGroupWorkspaceTableProps } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.types";
import { GroupWorkspaceRow } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupWorkspaceRow";

const WORKSPACE_COLUMN_HEADERS = [
  "Workspace",
  "Overall",
  "Budget",
  "Schedule",
  "Scope",
  "Milestones",
  "Deliverables",
  "RAID Logs",
];

const CENTERED_COLUMN_START_INDEX = 1;

export const GroupWorkspaceTable = ({
  workspaceRows,
}: IGroupWorkspaceTableProps): JSX.Element => {
  const styles = useGroupedWorkspaceDashboardStyles();

  if (workspaceRows.length === 0) {
    return (
      <div className={styles.noWorkspacesMessage}>
        No workspaces in this portfolio yet.
      </div>
    );
  }

  return (
    <div>
      <div
        className={mergeClasses(
          styles.workspaceGrid,
          styles.workspaceHeaderRow,
        )}
        role="row"
      >
        {WORKSPACE_COLUMN_HEADERS.map((header, index) => (
          <span
            key={header}
            role="columnheader"
            className={mergeClasses(
              styles.workspaceColumnHeader,
              index >= CENTERED_COLUMN_START_INDEX &&
                styles.workspaceColumnHeaderCentered,
            )}
          >
            {header}
          </span>
        ))}
      </div>

      {workspaceRows.map((rowData) => (
        <GroupWorkspaceRow key={rowData.workspace.id} rowData={rowData} />
      ))}
    </div>
  );
};
